// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageBlockEditor_root__wrkQ_"};